import Axios from "../config/Axios";

export const GET_PRODUCT_METRIC = "GET_PRODUCT_METRIC";
export const GET_REPORT_USER = "GET_REPORT_USER";
export const GET_ASSESSMENT = "GET_ASSESSMENT";
export const FILTER_METRIC_USER = "FILTER_METRIC_USER";
export const SORT_REPORT_BY_USERS = "SORT_REPORT_BY_USERS";
export const SORT_REPORT_USER = "SORT_REPORT_USER";
export const GET_METRIC_INITIAL_DATA = "GET_METRIC_INITIAL_DATA";
export const GET_REPORTS_BY_GROUP_PRODUCT = "GET_REPORTS_BY_GROUP_PRODUCT";
export const GET_SESSION = "GET SESSION";
export const GET_GENERAL_REPORT = "GET_GENERAL_REPORT";
export const GET_REPORTS_BY_PRODUCT = "GET_REPORTS_BY_PRODUCT";
export const SET_MODULE = "SET_MODULE";
export const SET_COURSE = "SET_COURSE";
export const GET_TOTAL_MODULES = "GET_TOTAL_MODULES";
export const GET_TOTAL_STUDENTS = "GET_TOTAL_STUDENTS";
export const GET_TOTAL_TIME_SPENT = "GET_TOTAL_TIME_SPENT";
export const GET_FULL_COMPLETION_STUDENTS = "GET_FULL_COMPLETION_STUDENTS";
export const GET_TOTAL_RATE = "GET_TOTAL_RATE";
export const CLEAR_REPORTS = "CLEAR_REPORTS";
export const UPDATE_REPORTS_INFO = "UPDATE_REPORTS_INFO";

const { REACT_APP_API_URL } = process.env;

const getReportsByGroupProduct = (data) => {
  return (dispatch) => {
    return Axios.get(
      `${REACT_APP_API_URL}/metrics/reports-by-group-and-product/${data.idProduct}/${data.idCourse}`
    )
      .then((response) => {
        dispatch({
          type: GET_REPORTS_BY_GROUP_PRODUCT,
          payload: response.data.response,
        });
        return response.data.response;
      })
      .catch((error) => {
        console.log(error);
        throw new Error(error);
      });
  };
};

const getProductMetric = () => {
  return (dispatch) => {
    return Axios.get(`${REACT_APP_API_URL}/metrics/listProducts`)
      .then((response) => {
        dispatch({
          type: GET_PRODUCT_METRIC,
          payload: response.data,
        });
      })
      .catch((error) => {
        throw new Error(error);
      });
  };
};

const getReportByUser = (data) => {
  return (dispatch) => {
    return Axios.get(
      `${REACT_APP_API_URL}/metrics/reportByUsername/${data.username}/${data.idProduct}`
    )
      .then((response) => {
        dispatch({
          type: GET_REPORT_USER,
          payload: response.data.response,
        });
      })
      .catch((error) => {
        throw new Error(error);
      });
  };
};

const getAssessment = (idSession) => {
  return (dispatch) => {
    return Axios.get(`${REACT_APP_API_URL}/metrics/assessments/${idSession}`)
      .then((response) => {
        dispatch({
          type: GET_ASSESSMENT,
          payload: response.data,
        });
      })
      .catch((error) => {
        throw new Error(error);
      });
  };
};

const filterUsersMetric = (str) => {
  return (dispatch) => {
    dispatch({
      type: FILTER_METRIC_USER,
      payload: str,
    });
  };
};

const sortReportsByUsers = (sort) => {
  return (dispatch) => {
    dispatch({
      type: SORT_REPORT_BY_USERS,
      payload: sort,
    });
  };
};

const sortReportUser = (sort) => {
  return (dispatch) => {
    dispatch({
      type: SORT_REPORT_USER,
      payload: sort,
    });
  };
};

const getMetricInitialData = () => {
  return (dispatch) => {
    return Axios.get(`${REACT_APP_API_URL}/metrics/getInitialData`)
      .then((response) => {
        dispatch({
          type: GET_METRIC_INITIAL_DATA,
          payload: response.data.response,
        });
      })
      .catch((error) => {
        throw new Error(error.response.data.message);
      });
  };
};

const getSession = (idSession) => {
  return (dispatch) => {
    return Axios.get(`${REACT_APP_API_URL}/metrics/getSession/${idSession}`)
      .then((response) => {
        dispatch({
          type: GET_SESSION,
          payload: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        throw new Error(error);
      });
  };
};

const getGeneralReport = (data) => {
  return (dispatch) => {
    return Axios.get(`${REACT_APP_API_URL}/metrics/generalInformation`)
      .then((response) => {
        dispatch({
          type: GET_GENERAL_REPORT,
          payload: response.data.response,
        });
        return response.data.response;
      })
      .catch((error) => {
        throw new Error(error);
      });
  };
};

const getTotalModules = () => {
  return (dispatch) => {
    return Axios.get(`${REACT_APP_API_URL}/metrics/total-modules/client`)
      .then((response) => {
        dispatch({
          type: GET_TOTAL_MODULES,
          payload: response.data.response,
        });
        return response.data.response;
      })
      .catch((error) => {
        throw new Error(error);
      });
  };
};

const getTotalStudents = () => {
  return (dispatch) => {
    return Axios.get(`${REACT_APP_API_URL}/metrics/total-students/client`)
      .then((response) => {
        dispatch({
          type: GET_TOTAL_STUDENTS,
          payload: response.data.response,
        });
        return response.data.response;
      })
      .catch((error) => {
        throw new Error(error);
      });
  };
};

const getTotalTimeSpent = () => {
  return (dispatch) => {
    return Axios.get(`${REACT_APP_API_URL}/metrics/total-time-spent/client`)
      .then((response) => {
        dispatch({
          type: GET_TOTAL_TIME_SPENT,
          payload: response.data.response,
        });
        return response.data.response;
      })
      .catch((error) => {
        throw new Error(error);
      });
  };
};

const getFullCompletionUsers = () => {
  return (dispatch) => {
    return Axios.get(
      `${REACT_APP_API_URL}/metrics/full-completion-users/client`
    )
      .then((response) => {
        dispatch({
          type: GET_FULL_COMPLETION_STUDENTS,
          payload: response.data.response,
        });
        return response.data.response;
      })
      .catch((error) => {
        throw new Error(error);
      });
  };
};

const getTotalRate = () => {
  return (dispatch) => {
    return Axios.get(`${REACT_APP_API_URL}/metrics/total-rate/client`)
      .then((response) => {
        dispatch({
          type: GET_TOTAL_RATE,
          payload: response.data.response,
        });
        return response.data.response;
      })
      .catch((error) => {
        throw new Error(error);
      });
  };
};

const getReportsByProduct = (data) => {
  return (dispatch) => {
    return Axios.get(`${REACT_APP_API_URL}/metrics/reportsByProduct`, {
      params: data,
    })
      .then((response) => {
        dispatch({
          type: GET_REPORTS_BY_PRODUCT,
          payload: response.data.response,
        });
        return response.data.response;
      })
      .catch((error) => {
        console.log(error);
        throw new Error(error);
      });
  };
};

const setModule = (idModule) => {
  console.log("setModule action called with idModule:", idModule);
  return (dispatch) => {
    dispatch({
      type: SET_MODULE,
      payload: idModule,
    });
  };
};

const setCourse = (idCourse) => {
  return (dispatch) => {
    dispatch({
      type: SET_COURSE,
      payload: idCourse,
    });
  };
};

const clearReports = ({ exclude } = {}) => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_REPORTS,
      payload: { exclude },
    });
  };
};

const updateReportsInfo = (data) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_REPORTS_INFO,
      payload: data,
    });
  };
};

export {
  getReportsByGroupProduct,
  getProductMetric,
  getReportByUser,
  getAssessment,
  filterUsersMetric,
  sortReportsByUsers,
  sortReportUser,
  getMetricInitialData,
  getSession,
  getGeneralReport,
  getReportsByProduct,
  setModule,
  setCourse,
  getTotalModules,
  getTotalStudents,
  getTotalTimeSpent,
  getFullCompletionUsers,
  getTotalRate,
  clearReports,
  updateReportsInfo,
};
